export default __webpack_public_path__ + "static/media/lp-1-rMIN.8aa661bc.avif";